import type { SVGProps } from 'react';
const SvgHourglassTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#hourglass_top_svg__a)">
      <path
        fill="currentColor"
        d="m6 2 .01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6Zm10 14.5V20H8v-3.5l4-4 4 4Z"
      />
    </g>
    <defs>
      <clipPath id="hourglass_top_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHourglassTop;
